import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { getActivityPartConstraintLifetime } from './getActivityPartConstraintLifetime'

export const getLifeTimeTimeoutAccordingConstraints = (
  activityParts: FrontActivityPart<FrontActivityWithAggregate>[],
): number | null => {
  const stack = [...activityParts]

  let minimalLifetimeInMileSeconds = Infinity
  while (stack.length > 0) {
    const currentActivityPart = stack.pop()!

    stack.push(...currentActivityPart.childActivity.children)

    if (!currentActivityPart.activityConstraint) {
      continue
    }

    const lifeTimeInMileSeconds = getActivityPartConstraintLifetime(currentActivityPart)

    // null means no constraint
    if (lifeTimeInMileSeconds === null) {
      continue
    }

    minimalLifetimeInMileSeconds = Math.min(minimalLifetimeInMileSeconds, lifeTimeInMileSeconds)
  }

  return minimalLifetimeInMileSeconds === Infinity ? null : minimalLifetimeInMileSeconds
}
